import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '../../../mutation/auth';
import { Spin } from 'antd';

function SignIn() {
  const { mutate, isLoading } = useGoogleLogin();
  return (
    <Spin spinning={isLoading} tip="Signing in...">
      <h1>Welcome to</h1>
      <h4 style={{ marginBottom: 20, padding: 0 }}>
        Email Communication System
      </h4>
      <GoogleLogin
        hosted_domain="turing.com"
        size="large"
        onSuccess={response => {
          mutate({ idToken: response.credential });
        }}
      />
    </Spin>
  );
}

export default SignIn;
